import React from "react";

const DescriptionEmployeeHealthCheckup = () => {
  return (
    <div className="employeecheckup-container">
      <div className="employeecheckup-hero">
        <h1 className="employeecheckup-title">Want to Arrange
          <span className="pinkhighlig"> Employee Health Checkups?</span>
        </h1>
      </div>

      <div className="employeecheckup-content">
        <p>Looking to keep your team healthy and productive?</p>

        <p>
          You can now post a request on <strong>Dr Planete</strong> to organize employee health checkups at your office, factory, or workplace.
        </p>

        <p><strong>These checkups help in:</strong></p>
        
          <li>Early detection of health issues</li>
          <li>Reducing sick leaves</li>
          <li>Boosting employee well-being</li>
          <li>Promoting a healthy work culture</li>
        

        <p><strong>How It Works:</strong></p>
        
          <p>Post your health checkup request for employees on <strong>Dr Planete</strong>.</p>
          <p>Doctors, dentists, and hospitals on our platform will be notified.</p>
          <p>Interested professionals will reach out to you directly if they are available.</p>
        
      </div>
    </div>
  );
};

export default DescriptionEmployeeHealthCheckup;

// CSS styles (in the same file)
const style = document.createElement("style");
style.innerHTML = `
  .employeecheckup-container {
    margin: 0 auto;
    width: 100%;
    font-family: 'Poppins', sans-serif;
  }

  .employeecheckup-hero {
    background: black;
    text-align: center;
    padding: 2rem 1rem;
    border-radius: 0px;
    margin-bottom: 2rem;
  }

  .employeecheckup-subtitle {
    color: black;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 10px;
  }

  .employeecheckup-title {
    font-size: 50px;
    color: white;
    font-weight: 700;
  }

  .pinkhighlig {
    color: #FF4081;
  }

  .employeecheckup-content {
    font-size: 18px;
    line-height: 1.6;
    color: #333;
    padding: 0 1rem;
  }

  .employeecheckup-content ul,
  .employeecheckup-content ol {
    margin-left: 1.5rem;
    padding-left: 0.5rem;
  }

  .employeecheckup-content li {
    margin-bottom: 0.5rem;
  }

  @media (max-width: 768px) {
    .employeecheckup-title {
      font-size: 36px;
    }

    .employeecheckup-subtitle {
      font-size: 20px;
    }

    .employeecheckup-content {
      font-size: 19px;
    }
  }
`;
document.head.appendChild(style);
